import {Component, OnInit, AfterViewInit, Output, Input, EventEmitter} from '@angular/core';
import {Router} from "@angular/router";
import { TokenCancelService } from '../../lib/services/token-cancel/token-cancel.service';
import {ToastService} from "../../lib/services/toast/toast.service";
import {AuthenticationService} from "../../lib/services/autenticacion/authentication.service";
import {UserBlockedService} from "../../lib/services/user-blocked/user-blocked-service.service";
import {TokenUnlockService} from "../../lib/services/token-unlock/token-unlock.service";
import {TokenCancelSuccessService} from "../../lib/services/token-cancel-success/token-cancel-success.service";

@Component({
  selector: 'lib-token-cancel',
  templateUrl: './token-cancel.component.html',
  styleUrls: ['./token-cancel.component.scss']
})
export class TokenCancelComponent implements OnInit, AfterViewInit {

  frame1: boolean = false;
  modalCancelMessage = ''
  modalCancelTokenMessage = ''
  codeSent = true;
  validating: boolean = false;
  resending: boolean = false;
  codeIntroduced: string;
  errorCodeIntroduced: boolean = false;
  validCode: boolean = false
  cancelaToken: boolean = true;
  capturaTokenCancela: boolean = false;

  constructor(
    private tokenCancelService: TokenCancelService,
    private toastService: ToastService,
    private router: Router,
    private tokenCancelSuccessService: TokenCancelSuccessService,
    private authenticationService: AuthenticationService,
    private userBlockedService: UserBlockedService,
    private tokenUnlockService: TokenUnlockService) { }

  cancelarToken(){
    this.tokenCancelService.sentEmailCode().subscribe({
      next: value => {
        this.toastService.showToast(value.message, "success", "Success")
        return
      },
      error: err => {
        if (err.error.errorCode === "USR02") {
          console.log(err)
          this.toastService.showToast(`${err.error.errorDescription}, please try again`, "error", "Error")
          return;
        } else if (err.error.errorCode == "USR05") {
          this.toastService.showToast(err.error.errorDescription, "error", "Error")
          return;
        }
        if (err.error.errorCode === "USR06") {
          this.toastService.showToast(err.error.errorDescription, "error", "Error")
          this.tokenCancelService.close()
          this.tokenUnlockService.tokenBlockError = true
          this.authenticationService.logOutWithoutRedirect()
          return;
        }
      },
    })

    this.cancelaToken = false;
    this.capturaTokenCancela = true;
  }
  salir(){
    this.closeModal();
  }

  onCodeChanged(event: any) {
    this.errorCodeIntroduced = false
    if(!event || event.length < 6){
      this.validCode = false;
    }
  }

  onCodeCompleted(event: any) {
    this.validCode = true;
    this.codeIntroduced = event
  }

  resendCodeEmail() {
    this.resending = true
    this.tokenCancelService.sentEmailCode().subscribe({
      next: value => {
        this.toastService.showToast(value.message, "success", "Success")
        this.resending = false
      }, error: err => {
        this.resending = false
        if (err.error.errorCode == "USR02") {
          console.log(err)
          this.toastService.showToast(`${err.error.errorDescription}, please try again`, "error", "Error")
          return;
        }else if (err.error.errorCode == "USR06" ) {
          this.tokenCancelService.close()
          this.tokenUnlockService.tokenBlockError = true
          this.authenticationService.logOutWithoutRedirect()
          this.toastService.showToast(err.error.errorDescription, "error", "Error")
          return;
        }
      }
    })
  }

  validateCode() {
    this.validating = true;
    if (this.codeIntroduced !== '' && this.codeIntroduced !== null && this.codeIntroduced.length >= 6) {
      this.tokenCancelService.validateCode(this.codeIntroduced).subscribe({
        next: value => {
          this.toastService.showToast(value.message, "success", "Success")
          this.closeModal();
          this.tokenCancelSuccessService.open()
          this.validating = false;
        },
        error: err => {
          this.validating = false;
          if (err.error.errorCode == "USR05") {
            console.log(err)
            this.toastService.showToast(err.error.errorDescription, "error", "Error")
            return;
          } else if(err.error.errorCode == "USR04") {
            console.log(err)
            this.errorCodeIntroduced = true
            return;
          } else if (err.error.errorCode == "USR03") {
            console.log(err)
            this.tokenCancelService.close()
            this.tokenUnlockService.tokenBlockError = true
            // this.userBlockedService.open()
          }
        }
      })
    }
  }

  ngOnInit(): void {
  }

  closeModal() {
    this.tokenCancelService.close()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.codeSent = false
    }, 3000)
}

}
